import React, { useEffect, useState } from "react";
import axios from "axios";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";import { CircularProgress } from "@mui/material";

function MemberCountExcel({ month, year, dist_code, afso_code, heading }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const [district, setDistrict] = useState("");
  const[homestate,setHomestate]=useState("");
  const [afso, setAfso] = useState("");
const downloaddate = new Date().toLocaleString("en-GB", { 
  year: "numeric", 
  month: "2-digit", 
  day: "2-digit", 
  hour: "2-digit", 
  minute: "2-digit", 
  second: "2-digit" 
});
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_URL}/api/member-count/data`, {
        params: { month, year, distCode: dist_code, afsoCode: afso_code },
      })
      .then((res) => {
        if (res.data?.data?.length > 0) {
          setData(res.data.data);
          setDistrict(res.data.district || "ALL");
          setAfso(res.data.afsoName || "ALL");
          setHomestate(res.data.homestate || "");
          setNoData(false);
        } else {
          setNoData(true);
        }
      })
      .catch(() => setNoData(true))
      .finally(() => setLoading(false));
  }, [month, year, dist_code, afso_code]);

const downloadExcel = async () => {
  if (!data || data.length === 0) return;

  const fileName = `Member_Count_${month}_${year}_${dist_code}.xlsx`;
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Member Count");
    // Define static headers and keys
  const staticHeaders = ["Sl. No.", "District Name ", "AFSO Name ", "FPS ID"];
  const staticKeys = [null, "dist_name_en", "afso_name_en", "fps_id"];
  const numStatic = staticHeaders.length;

  const schemeCols = [];
const schemeSet = new Set();

data.forEach(row => {
  Object.keys(row.schemes).forEach(scheme => {
    if (!schemeSet.has(scheme)) {
      schemeCols.push(scheme);  // preserve order
      schemeSet.add(scheme);
    }
  });
});

  // Get ranges for each scheme
  const schemeRanges = {};
  schemeCols.forEach((scheme) => {
    const sample = data.find((row) => row.schemes && row.schemes[scheme]);
    schemeRanges[scheme] = sample ? Object.keys(sample.schemes[scheme]).sort() : [];
  });

  const colGroups = schemeCols.map((scheme) => ({
    scheme,
    ranges: schemeRanges[scheme],
    numCols: schemeRanges[scheme].length,
  }));

// Add top title row
worksheet.addRow([`Units wise cards details - ${month}-${year} for District: ${district} /Afso: ${afso} | State:${homestate}| Generated on: ${downloaddate}`]);
worksheet.mergeCells(1, 1, 1, numStatic + colGroups.reduce((sum, g) => sum + g.numCols, 0)); 
// After adding title row
const titleRow = worksheet.getRow(1);
titleRow.font = { bold: true, size: 14 };
titleRow.getCell(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFF9900" } };
titleRow.alignment = { horizontal: "center", vertical: "middle" };



const headerRowIndex = 2; // row 2 for first header
const headerRow1 = [];
const headerRow2 = [];

// Static headers
for (let i = 0; i < numStatic; i++) {
  headerRow1.push(staticHeaders[i]);
  headerRow2.push(""); // vertical merge
}
colGroups.forEach((group) => {
  const schemeName = `${group.scheme} cards`;
  headerRow1.push(schemeName, ...Array(group.numCols - 1).fill(""));
  headerRow2.push(...group.ranges);
});

// Add header rows
worksheet.addRow(headerRow1); // row 2
worksheet.addRow(headerRow2); // row 3

// Merge static headers vertically
for (let i = 0; i < numStatic; i++) {
  worksheet.mergeCells(headerRowIndex, i + 1, headerRowIndex + 1, i + 1);
}

// Merge scheme headers horizontally
let currentCol = numStatic + 1;
colGroups.forEach((group) => {
  if (group.numCols > 1) {
    worksheet.mergeCells(headerRowIndex, currentCol, headerRowIndex, currentCol + group.numCols - 1);
  }
  currentCol += group.numCols;
});


  // Style header rows
  [2, 3].forEach((rowNumber) => {
    const row = worksheet.getRow(rowNumber);
    row.eachCell((cell) => {
      cell.font = { bold: true };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFF9900" } }; // Changed from "#ff9900"
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  // Add data rows
  data.forEach((rowData, idx) => {
    const rowArr = [idx + 1];
    for (let k = 1; k < staticKeys.length; k++) {
      rowArr.push(rowData[staticKeys[k]] || "");
    }
    schemeCols.forEach((scheme) => {
      const counts = rowData.schemes?.[scheme] || {};
      schemeRanges[scheme].forEach((range) => {
        rowArr.push(counts[range] || 0);
      });
    });
    worksheet.addRow(rowArr);
  });
// Add totals row
const totalsRow = [];
totalsRow.push("Total", "", "", ""); 
schemeCols.forEach((scheme) => {
  schemeRanges[scheme].forEach((range) => {
    const total = data.reduce((sum, row) => sum + (row.schemes?.[scheme]?.[range] || 0), 0);
    totalsRow.push(total);
  });
});
worksheet.addRow(totalsRow);

// Style totals row
// Replace your entire totals row styling with this:
const lastRowNumber = worksheet.lastRow.number;

// Merge first 4 columns for "Total"
worksheet.mergeCells(lastRowNumber, 1, lastRowNumber, 4);

// Set the value in the merged cell
const lastRow = worksheet.getRow(lastRowNumber);
lastRow.getCell(1).value = "Total"; // only the top-left cell holds the value

// Apply style to all cells in the row
lastRow.eachCell((cell, colNumber) => {
  cell.font = { bold: true };
  cell.fill = {
    type: "pattern",
    pattern: "solid",
   fgColor: { argb: "FFFF9900" }// Light green background
  };
  cell.alignment = { horizontal: "center", vertical: "middle" };

  // Double line on top of total row
  cell.border = {
    top: { style: "double", color: { argb: "FF000000" } },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" }
  };
});

  // Set column widths
  const colWidths = [
    { width: 6 }, // Sl. No.
    ...Array(numStatic - 1).fill({ width: 18 }), // Names / IDs
    ...Array(colGroups.reduce((sum, g) => sum + g.numCols, 0)).fill({ width: 12 }),
  ];
  worksheet.columns = colWidths;

  // Export Excel
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), fileName);
};

  if (loading)
    return (
      <div style={{ textAlign: "center" }}>
        <CircularProgress />
      </div>
    );

  if (noData)
    return (
      <div className="response" style={{ textAlign: "center", color: "red", marginTop: "10px" }}>
        No data found
      </div>
    );

  return (
    <div style={{ margin: "20px" }}>
      <h3 style={{ textAlign: "center", marginBottom: "15px", color: "#333" }}>
        {  `Units wise cards details  ${month}-${year} for District: ${district} /Afso: ${afso}`}
      </h3>
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <button className="button button2" onClick={downloadExcel}>
          Download Excel
        </button>
      </div>
    </div>
  );
}

export default MemberCountExcel;